import { Component, Output, Input, EventEmitter } from '@angular/core';
import { Log } from '../../../utils/index';
import { IUserFilter, ListResult, User } from '../../../entities/index';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'app-user-filters',
  templateUrl: './user-filters.html'
})
export class UserFilterComponent {
  
  userFilter: IUserFilter;
  inputValueLastName: string;
  inputValueFirstName: string;
  applyOff: boolean = true; // Disable or Enable boutton apply
  deletedOff: boolean = true; // Disable or Enable boutton deleted
  firstName: string;
  lastName: string
  users: Observable<ListResult<User>>;
  boxOne: boolean = false;
  tempo: NodeJS.Timer; // Instant setTimeout (tempo)

  @Output()
  resultUserFilter: EventEmitter<IUserFilter> = new EventEmitter<IUserFilter>();

  async keySave(): Promise<void> {

    // Retrieve the entered value
    this.firstName = this.inputValueFirstName
    this.lastName = this.inputValueLastName
    this.applyOff = false; // Enable boutton apply
    this.deletedOff = false; // Enable boutton deleted
    
    // Tempo 1 sc for save change initiate by keyup
    clearTimeout(this.tempo); // Cancels the tempo
    // Instantiated tempo 
    this.tempo=setTimeout(() => {this.save()} // Emit userFilter in resultIUserFilter
      ,1000 // Time tempo 1 sc
    );
  }          

  @Log('blue')
  // Active fot ngSubmit Boutton Save, emit userFilter in resultIUserFilter
  save() {
    clearTimeout(this.tempo); // Cancels the tempo
    this.userFilter = new IUserFilter();
    this.userFilter.first_name = this.firstName;
    this.userFilter.last_name = this.lastName;
    this.resultUserFilter.emit(this.userFilter);
    this.applyOff = true; // Disable boutton apply
  }

  // Active fot click Boutton +/- in BoxCollapse
  collapsed(){

    // Close BoxCollapse 
    if(this.boxOne){
      this.boxOne = false;

      // Deleted the text input area
      this.inputValueLastName = "";
      this.inputValueFirstName = "";

      // Deleted all value 
      if(this.userFilter){
        this.deleted();
      }

    // Open BoxCollapse 
    }else{
      this.boxOne = true;
    }
  }

  @Log('blue')
  deleted() {
    // Deleted the text input area
    this.inputValueLastName = "";
    this.inputValueFirstName = "";

    this.userFilter = new IUserFilter(); // not null but voids 
    this.deletedOff = true; // Disable boutton deleted
    this.applyOff = true; // Disable boutton apply

    // Emit filter is null
    this.resultUserFilter.emit(this.userFilter);
  }
}



// WEBPACK FOOTER //
// /builds/weenect1/backofficev3/src/app/components/blocks/user-filter/user-filters.component.ts